import { TabsProps, Tabs as RACTabs } from "react-aria-components";

export default function Tabs(props: TabsProps) {
  return <RACTabs {...props} />;
}
